import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalService } from '../../services/modal.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-modal',
    templateUrl: './modal-external.component.html',
    standalone: false
})
export class ModalExternalComponent implements OnInit {
  urlSafe;
  constructor(
    public dialogRef: MatDialogRef<ModalExternalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    public sanitizer: DomSanitizer
  ) {
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(modalData.url);
  }

  ngOnInit() {}

  actionFunction(action) {
    this.closeModal(action);
  }

  closeModal(action) {
    this.dialogRef.close(action);
  }
}
